import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaHome,
  FaIdCard,
  FaImages,
  FaFilePdf,
} from "react-icons/fa";
import logo from "../assets/merge-image.webp";

const Footer: React.FC = () => {
  return (
    <>
      {/* Main Footer for Desktop */}
      <footer className="bg-gradient-to-r from-blue-900 via-blue-800 to-blue-700 text-white pt-16 rounded-t-3xl shadow-inner pb-8 hidden md:block">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 text-left">
            {/* About */}
            <div>
              <div className="flex items-center gap-4 mb-6">
                <img
                  src={logo}
                  alt="Logo"
                  className="w-36 h-auto object-contain"
                />
              </div>
              <p className="text-sm leading-relaxed text-blue-100 font-medium">
                Simplifying image manipulation and editing, helping users
                seamlessly merge and enhance images for creative projects.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
              <ul className="space-y-3 text-base font-medium text-blue-100">
                {["Home", "About", "FAQ", "ID Card Merge Tool"].map(
                  (item, index) => (
                    <li key={index}>
                      <a
                        href="/"
                        className="hover:text-blue-300 transition duration-200"
                      >
                        {item}
                      </a>
                    </li>
                  )
                )}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-lg font-semibold mb-6">Contact Us</h3>
              <p className="text-base text-blue-100 font-medium">
                Email:{" "}
                <a
                  href="mailto:stackasian@gmail.com"
                  className="hover:text-blue-300 transition duration-200"
                >
                  stackasian@gmail.com
                </a>
              </p>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-12 border-t border-blue-600 pt-6 text-center">
            <div className="flex justify-center space-x-4 mb-6">
              {[FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn].map(
                (Icon, idx) => (
                  <a
                    key={idx}
                    href="#"
                    className="p-2 bg-blue-800 hover:bg-blue-700 rounded-full transition"
                  >
                    <Icon className="text-white text-lg" />
                  </a>
                )
              )}
            </div>

            <p className="text-sm text-blue-200">
              &copy; {new Date().getFullYear()} Merge Images. All rights
              reserved.
            </p>

            <div className="mt-3 space-x-4 text-sm text-blue-100">
              <a
                href="/privacy-policy"
                className="hover:text-blue-300 transition duration-200"
              >
                Privacy Policy
              </a>
              <a
                href="/terms-of-service"
                className="hover:text-blue-300 transition duration-200"
              >
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Mobile Bottom Navigation */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-inner z-50">
        <div className="flex justify-around items-center py-2">
          <a href="/" className="flex flex-col items-center text-blue-700 hover:text-blue-900">
            <FaHome className="text-xl mb-1" />
            <span className="text-xs">Home</span>
          </a>
          <a href="/id-card" className="flex flex-col items-center text-blue-700 hover:text-blue-900">
            <FaIdCard className="text-xl mb-1" />
            <span className="text-xs">ID Merger</span>
          </a>
          <a href="/collages" className="flex flex-col items-center text-blue-700 hover:text-blue-900">
            <FaImages className="text-xl mb-1" />
            <span className="text-xs">Collages</span>
          </a>
          <a href="https://imagestopdf.stackasian.com/merge-pdf" className="flex flex-col items-center text-blue-700 hover:text-blue-900">
            <FaFilePdf className="text-xl mb-1" />
            <span className="text-xs">Merge PDF</span>
          </a>
        </div>
      </nav>
    </>
  );
};

export default Footer;
